import { render, staticRenderFns } from "./station-planview-edit.vue?vue&type=template&id=2bc5021b&scoped=true&"
import script from "./station-planview-edit.vue?vue&type=script&lang=js&"
export * from "./station-planview-edit.vue?vue&type=script&lang=js&"
import style0 from "./station-planview-edit.vue?vue&type=style&index=0&id=2bc5021b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5021b",
  null
  
)

export default component.exports